import { authApi } from "./index";

export const getUserEarnings = async (userId, token) => {
  try {
    const response = await authApi.get(
      `Reward/User-Earnings/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "*/*",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getRewardRules = async (token) => {
  try {
    const response = await authApi.get(
      `Reward/reward-rules`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "*/*",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getLeaderboard = async (token) => {
  try {
    const response = await authApi.get(
      `Reward/leaderboard`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "*/*",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};


